import React, { useEffect, useState } from "react";
import { formatStackBB } from "./helpers";

export default function ActionPanel({
  mySeatNo,
  myInHand,
  isMyTurn,
  actionSeat,
  waitingForDealer,
  dealerStepLabel,
  isDealer,

  canAct,
  foldDisabled,
  passiveDisabled,
  aggressiveDisabled,

  passiveType,
  passiveLabel,

  aggressiveType,
  aggressiveLabel,

  hasBet,
  clampedTo,
  minAllowedTo,
  minRaiseTo,
  maxRaiseTo,
  bb,
  potVal,
  toCall,
  currentBet,

  // stack/amount display
  stackViewMode = "chips",
  bbAmount = bb,

  // ✅ NEW
  street,

  setRaiseTo,
  doAction,
}) {
  const [textValue, setTextValue] = useState(String(clampedTo || 0));
  const [showAdvanced, setShowAdvanced] = useState(false); // domyślnie ukryte

  useEffect(() => {
    setTextValue(String(clampedTo || 0));
  }, [clampedTo]);

  const clampToAllowed = (v) => {
    const max = Number(maxRaiseTo || 0);
    const min = Number(minAllowedTo || 0);
    const x = Number(v || 0);
    if (!max) return Math.max(min, x);
    return Math.max(min, Math.min(x, max));
  };

  const isPreflop = street === "preflop";

  // ✅ preflop i "tylko blindy"
  const preflopOnlyBlinds = isPreflop && Number(bb || 0) > 0 && Number(currentBet || 0) === Number(bb || 0);

  // ✅ postflop+ i brak betu na ulicy => otwarcie (bet)
  const streetOpenBet = !hasBet && !isPreflop;

  // ===============================
  // Szybkie targety: "do X BB"
  // ===============================
  const quickBlindTargets = [
    { label: "2 BB", v: 2 * bb },
    { label: "3 BB", v: 3 * bb },
    { label: "4 BB", v: 4 * bb },
  ];

  const potAfterCall = Number(potVal || 0) + Number(toCall || 0);
  const cb = Number(currentBet || 0);
  const tc = Number(toCall || 0);

  const fmtAmt = (v) => {
    const n = Number(v);
    const bbA = Number(bbAmount);
    if (!Number.isFinite(n)) return "—";
    if (stackViewMode === "bb" && Number.isFinite(bbA) && bbA > 0) return `${formatStackBB(n, bbA)} BB`;
    return String(n);
  };

  const raiseToFromFraction = (fraction) => {
    const targetTo = cb + tc + fraction * potAfterCall;
    return clampToAllowed(Math.round(targetTo));
  };

  const quickRaiseTargets = [
    { label: "o 1/4 puli", f: 1 / 4 },
    { label: "o 1/3 puli", f: 1 / 3 },
    { label: "o 1/2 puli", f: 1 / 2 },
  ];

  const betToFromFraction = (fraction) => {
    const targetTo = Number(potVal || 0) * fraction;
    return clampToAllowed(Math.round(targetTo));
  };

  const quickOpenBetTargets = [
    { label: "1/3 puli", f: 1 / 3 },
    { label: "1/2 puli", f: 1 / 2 },
    { label: "3/4 puli", f: 3 / 4 },
    { label: "pula", f: 1 },
  ];

  const handleTextCommit = () => {
    const numeric = clampToAllowed(Number(textValue || 0));
    setRaiseTo(numeric);
  };

  // ✅ wybór trybu szybkich przycisków + label
  let quickMode = "NONE"; // "BLINDS" | "RAISE" | "OPEN_BET"
  let amountLabel = hasBet ? "Raise do:" : "Bet:";
  let quickTitle = null;

  if (preflopOnlyBlinds) {
    quickMode = "BLINDS";
    amountLabel = "Podbij do:";
    quickTitle = "Szybki wybór (preflop):";
  } else if (streetOpenBet) {
    quickMode = "OPEN_BET";
    amountLabel = "Otwarcie (bet):";
    quickTitle = "Szybki wybór (otwarcie):";
  } else if (hasBet) {
    quickMode = "RAISE";
    amountLabel = "Przebij do:";
    quickTitle = "Szybki wybór (raise):";
  } else {
    quickMode = "BLINDS";
    amountLabel = "Bet:";
    quickTitle = "Szybki wybór:";
  }

  // ✅ kompaktowe style
  const btnStyle = { padding: "7px 10px", fontSize: 13, lineHeight: 1.1 };
  const sectionStyle = {
    border: "1px solid rgba(255,165,0,0.25)",
    borderRadius: 12,
    padding: 10,
  };

  // ✅ 3 kafle
  const triGrid = {
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)",
    gap: 10,
  };

  // ~30% mniejsze
  const triBtn = {
    padding: "7px 8px",
    height: 55,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    lineHeight: 1.05,
    fontWeight: 900,
  };

  const triSub = { fontSize: 12, opacity: 0.82, fontWeight: 800, marginTop: 4 };

  // do kafelka CALL/CHECK – pokazuj tylko kwotę (albo 0)
  const passiveSub = (() => {
    const t = String(passiveType || "").toUpperCase();
    if (t === "CALL") return fmtAmt(Number(toCall || 0));
    if (t === "CHECK") return "0";
    return "";
  })();

  return (
    <div style={{ marginTop: 4 }}>
      <div style={{ fontSize: 13, fontWeight: 800, marginBottom: 4 }}>Akcje</div>

      <div style={{ marginTop: 6 }}>
        {mySeatNo == null ? (
          <div style={{ opacity: 0.85, fontSize: 13 }}>Usiądź w lobby, żeby grać.</div>
        ) : !myInHand ? (
          <div style={{ opacity: 0.85, fontSize: 13 }}>Nie jesteś w rozdaniu.</div>
        ) : !isMyTurn ? (
          <div style={{ opacity: 0.85, fontSize: 13 }}>
            Teraz nie Twoja tura. Gra seat: <b>{actionSeat ?? "-"}</b>
          </div>
        ) : (
          <div style={{ display: "grid", gap: 10 }}>
            {/* Kafle + toggle po prawej (na wąskim spada pod) */}
            <div style={{ display: "flex", gap: 10, alignItems: "center", flexWrap: "wrap" }}>
              <div style={{ flex: "1 1 260px", minWidth: 220 }}>
                <div style={triGrid}>
                  <button
                    className="btn btn-secondary"
                    style={{
                      ...triBtn,
                      border: "1px solid rgba(255,80,80,0.55)",
                      boxShadow: "0 0 12px rgba(255,80,80,0.10)",
                    }}
                    disabled={foldDisabled}
                    onClick={() => doAction("fold")}
                    type="button"
                    title="Fold"
                  >
                    <div style={{ fontSize: 14 }}>FOLD</div>
                  </button>

                  <button
                    className="btn btn-secondary"
                    style={triBtn}
                    disabled={passiveDisabled}
                    onClick={() => doAction(passiveType)}
                    type="button"
                    title={passiveLabel}
                  >
                    <div style={{ fontSize: 14 }}>{String(passiveType || "").toUpperCase()}</div>
                    <div style={triSub}>{passiveSub}</div>
                  </button>

                  <button
                    className="btn btn-primary"
                    style={triBtn}
                    disabled={aggressiveDisabled}
                    onClick={() => doAction(aggressiveType, clampedTo)}
                    type="button"
                    title={`${aggressiveLabel} ${fmtAmt(clampedTo)}`}
                  >
                    <div style={{ fontSize: 14 }}>{String(aggressiveType || "").toUpperCase()}</div>
                    <div style={triSub}>{fmtAmt(clampedTo)}</div>
                  </button>
                </div>
              </div>

              <button
                className="btn btn-secondary"
                type="button"
                style={{
                  padding: "6px 10px",
                  fontSize: 12,
                  whiteSpace: "nowrap",
                  alignSelf: "center",
                }}
                onClick={() => setShowAdvanced((v) => !v)}
              >
                {showAdvanced ? "Ukryj ustawianie kwoty" : "Ustaw kwotę"}
              </button>
            </div>

            {/* Zaawansowane ustawianie kwoty */}
            {showAdvanced ? (
              <div style={sectionStyle}>
                {!!quickTitle ? (
                  <div style={{ fontSize: 12, fontWeight: 800, opacity: 0.8, marginBottom: 8 }}>{quickTitle}</div>
                ) : null}

                {/* QUICK BUTTONS */}
                {quickMode === "BLINDS" ? (
                  <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 8, marginBottom: 10 }}>
                    {quickBlindTargets.map((x) => (
                      <button
                        key={x.label}
                        className="btn btn-secondary"
                        style={btnStyle}
                        type="button"
                        onClick={() => setRaiseTo(clampToAllowed(x.v))}
                        title={`Ustawia do: ${clampToAllowed(x.v)}`}
                      >
                        {x.label}
                      </button>
                    ))}
                  </div>
                ) : quickMode === "OPEN_BET" ? (
                  <div style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: 8, marginBottom: 10 }}>
                    {quickOpenBetTargets.map((x) => (
                      <button
                        key={x.label}
                        className="btn btn-secondary"
                        style={btnStyle}
                        type="button"
                        onClick={() => setRaiseTo(betToFromFraction(x.f))}
                        title={`Ustawia bet na: ${betToFromFraction(x.f)} (pula: ${Number(potVal || 0)})`}
                      >
                        {x.label}
                      </button>
                    ))}
                  </div>
                ) : (
                  <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 8, marginBottom: 10 }}>
                    {quickRaiseTargets.map((x) => (
                      <button
                        key={x.label}
                        className="btn btn-secondary"
                        style={btnStyle}
                        type="button"
                        onClick={() => setRaiseTo(raiseToFromFraction(x.f))}
                        title={`Ustawia raise do: ${raiseToFromFraction(x.f)} (pula po callu: ${potAfterCall})`}
                      >
                        {x.label}
                      </button>
                    ))}
                  </div>
                )}

                {/* INPUT */}
                <div style={{ fontWeight: 800, marginBottom: 6, fontSize: 13 }}>
                  {amountLabel} <b>{clampedTo}</b>
                  <span style={{ marginLeft: 8, opacity: 0.7, fontSize: 12 }}>(min: {minAllowedTo})</span>
                </div>

                <input
                  className="input-secondary"
                  type="number"
                  value={textValue}
                  onChange={(e) => setTextValue(e.target.value)}
                  onBlur={handleTextCommit}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") handleTextCommit();
                  }}
                  style={{ width: "100%" }}
                />

                <input
                  style={{ width: "100%", marginTop: 6 }}
                  type="range"
                  min={minAllowedTo}
                  max={maxRaiseTo || 0}
                  value={clampedTo}
                  onChange={(e) => setRaiseTo(Number(e.target.value))}
                />

                <div style={{ display: "flex", gap: 8, marginTop: 8 }}>
                  <button className="btn btn-secondary" style={btnStyle} type="button" onClick={() => setRaiseTo(minAllowedTo)}>
                    Min
                  </button>
                  <button className="btn btn-secondary" style={btnStyle} type="button" onClick={() => setRaiseTo(maxRaiseTo)}>
                    Max
                  </button>
                </div>

                <div style={{ opacity: 0.7, fontSize: 11, marginTop: 8 }}>
                  max: {fmtAmt(maxRaiseTo)} · pula: {fmtAmt(potVal)} · doCall: {fmtAmt(toCall)} · po callu: {fmtAmt(potAfterCall)} · street: {street ?? "-"}
                </div>
              </div>
            ) : null}

            {/* debug – zostawiasz na razie, później usuniemy */}
            <div style={{ opacity: 0.75, fontSize: 11 }}>
              {String(passiveType || "").toUpperCase()}: {passiveLabel} · {String(aggressiveType || "").toUpperCase()} {fmtAmt(clampedTo)}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
